<template>
  <section>
    <div class="row">
      <div class="form-group">
        <div v-if="!isDeal">
          <label>
            {{label}}
          </label>
          <table class="table table-bordered"
              :key="randomValue" >
          <thead>
          <tr>
            <th>Day</th>
            <th>Start Time</th>
            <th>Closing Time</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(day, index) in days"
              v-bind:key="index"
          >
            <td>
              {{day}}
            </td>
            <td>
              <div class="input-group startTimeClock"
                   >
                <input type="text"
                       :id="'start-'+index"
                       v-model="startTime[index]"
                       class="form-control"
                       readonly="readonly"
                       placeholder="Start time..." >
                <span class="input-group-addon">
                  <span class="fa fa-clock-o"/>
                </span>
              </div>
            </td>
            <td>
              <div class="input-group endTimeClock"
                   >
                <input type="text"
                       :id="'end-'+index"
                       class="form-control"
                       readonly="readonly"
                       v-model="endTime[index]"
                       placeholder="End time..." >
                <span class="input-group-addon">
                  <span class="fa fa-clock-o"/>
                </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
        <div v-else>
          <TimingsComponentWithSlots
              ref="timingComponentWithSlotsPopUp"
              :timings-obj="timingConfiguration"
              :label="label"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import TimingsComponentWithSlots from "./TimingsComponentWithSlots";
export default {
  name: "TimingsComponent",
  components: {TimingsComponentWithSlots},
  props: [
      'label',
      'isDeal',
      'updateTimingConfiguration'
  ],
  data() {
    return {
      validDays: new Array(7).fill(false),
      startTime: new Array(7).fill(null),
      endTime: new Array(7).fill(null),
      is24HoursAvailable: new Array(7).fill(false),
      timingConfiguration: [],
      days:["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      randomValue: Math.random(),
    }
  },
  watch: {
    updateTimingConfiguration: async function (value) {
      if (value.length > 0 && typeof value === 'object') {
        this.timingConfiguration = [...value];
        await this.addBranchTimings(this.timingConfiguration);
        this.randomValue = Math.random();
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
      }
      setTimeout(() => {
        this.jQueryForDealsTimingConfig();
      }, 500);
    }
  },
  mounted() {
    this.jQueryForDealsTimingConfig();
  },
  methods: {
    jQueryForDealsTimingConfig: function() {
      let self = this;
      for (let i = 0; i < 7; i++) {
        $("#start-" + i).datetimepicker({
          pickDate: false,
          format: 'hh:mmA',
          toolbarPlacement: 'bottom'
        }).on('dp.hide', function () {
          self.startTime[i] = $('.startTimeClock').find('input')[i].value;
        });
        $("#end-"+i).datetimepicker({
          pickDate: false,
          format: 'hh:mmA',
          toolbarPlacement: 'bottom'
        }).on('dp.hide', function () {
          self.endTime[i] = $('.endTimeClock').find('input')[i].value;
        });
      }
    },
    isValidTimingConfig: function (){
      for(let index = 0; index < this.days.length ; index++){
        if(this.startTime[index] === null || this.endTime[index] === null){
          swal("ERROR!", "Please insert timings of all 7 days in a week and that is important ok! or contact DVM Tech Support", "error");
          return false;
        }
      }
      return true;
    },
    convert24hr: function (time) {
      let AmPm = time.replace(/[^a-z]/gi, '');
      let phr = time.split(":")[0];
      let hr = parseInt(phr);
      AmPm==="PM" && hr===12 ? hr=12 : AmPm === "PM" ? hr = hr + 12 : hr;
      AmPm==="AM" && hr===12 ? hr=0 : hr;
      return (time.replace(/[a-z]/gi, '')).replace(('0' + phr).slice(-2), ('0' + hr).slice(-2));
    },
    makeArrayWithStartAndEndTime: function (name, index){
      let start = this.startTime[index] ? this.convert24hr(this.startTime[index]) : null;
      let end = this.endTime[index] ? this.convert24hr(this.endTime[index]) : null;
      return {
        "day": name,
        "starting": start,
        "closing": end,
      };
    },
    updateBranchTimings: function () {
      let branchTiming = [];
      if(!this.isDeal && this.isValidTimingConfig()) {
        this.days.forEach((name, index) => {
          let arr = this.makeArrayWithStartAndEndTime(name, index);
          branchTiming.push(arr);
        });
        return branchTiming;
      } else {
        return this.$refs.timingComponentWithSlotsPopUp.updateBranchTimings();
      }
    },
    convertStartAndEndTimeIn12Hours: function (time, day){
      (typeof time.starting === "number") && (time.starting = ('0' + time.starting).slice(-2) + ':00');
      (typeof time.closing === "number") && (time.closing = ('0' + time.closing).slice(-2) + ':00');

      console.log(time)
      let startHr = parseInt(time.starting.split(":")[0]);
      let startMin = time.starting.split(":")[1];
      if (startHr >= 12) {
        startHr === 12 ? this.startTime[day] = '12:' + startMin + 'PM' : this.startTime[day] = ('0' + (startHr - 12)).slice(-2) + ':' + startMin + 'PM';
      } else {
        startHr === 0 ? this.startTime[day] = '12:' + startMin + 'AM' : this.startTime[day] = ('0' + (startHr)).slice(-2) + ':' + startMin + 'AM';
      }

      let closeHr = parseInt(time.closing.split(":")[0]);
      let closeMin = time.closing.split(":")[1];
      if (closeHr >= 12) {
        closeHr === 12 ? this.endTime[day] = '12:' + closeMin + 'PM' : this.endTime[day] = ('0' + (closeHr - 12)).slice(-2) + ':' + closeMin + 'PM';
      } else {
        closeHr === 0 ? this.endTime[day] = '12:' + closeMin + 'AM' : this.endTime[day] = ('0' + (closeHr)).slice(-2) + ':' + closeMin + 'AM';
      }
    },
    addBranchTimings: function (timings) {
      if(!this.isDeal) {
        return timings.forEach((time) => {
          let day = this.days.indexOf(time.day);
          this.convertStartAndEndTimeIn12Hours(time, day);
        });
      }
    },
  }

}
</script>

<style scoped>

</style>